module.exports = __webpack_public_path__ + "img/step5.8ba04ac7.png";